import FormController from 'controllers/form-controller';

export default class RegistrationsDetailsFormController extends FormController {
  connect() {
    super.connect();
  }

  validateFields(event) {
    event.preventDefault();
    super.showSpinner();

    super.validateFields();

    this.validateFullName();
    this.validateUsername();

    if (this.formValid) {
      this.continueRegistration();
    } else {
      super.hideSpinner();
    }
  }

  continueRegistration() {
    this.checkNewsletterOption();
    this.submit();
  }

  checkNewsletterOption() {
    const newsletterOption = document.getElementById('newsletter');

    if (newsletterOption && newsletterOption.checked) {
      sessionStorage.setItem('newsletter_preference', 'newsletter_signup');
    } else {
      sessionStorage.setItem('newsletter_preference', 'no_newsletter_signup');
    }
  }
}
